import { faBell } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Col, Row } from "react-bootstrap";
import { IChangeRequestDetails } from "../../../api/IChangeRequests";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";

interface ChangeRequestDetailsProps {
  changeRequestDetails: IChangeRequestDetails;
}

const ChangeRequestDetails = ({
  changeRequestDetails,
}: ChangeRequestDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Amendment Title"}
            value={changeRequestDetails.title}
          />
          <EpaField
            label={"EPA Initiated"}
            value={changeRequestDetails.epainiciated}
          />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Request Date"}
            value={changeRequestDetails.requestdate}
          />
          <EpaField
            label={"Issued Date"}
            value={changeRequestDetails.issueddate}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return (
    <EpaCard title={"Auhtorisation Amendment Detail"} content={bodyElements} />
  );
};

export default ChangeRequestDetails;
